import Icon7 from "./icon7";

export default function HeartContainer() {
  return (
    <div className=" flex justify-self-end ">
      <Icon7 />
    </div>
  );
}
